import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { makeObservable } from 'mobx';

const drawForm = {
  fields: {
    drawId: {
      value: '',
      error: null,
      rule: 'required',
    },
    propertyId: {
      value: '',
      error: null,
      rule: 'required',
    },
    sectionId: {
      value: '',
      error: null,
      rule: 'required',
    }
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    showErrors: null,
    error: null,
  },
}
export class DrawFormStore extends FormStore {
  private globalStore: GlobalStore;
  constructor(globalStore) {
    super({ ...drawForm }, globalStore);
    this.globalStore = globalStore;
  }
}